<template>
    <li class="d-flex flex-column flex-fill" style="border-color: #17202e !important;">
        <div class="rounded flex-fill d-flex align-items-center justify-content-between py-1" elem>
            <div class="d-flex align-items-center">
                <button 
                    class="btn p-0 text-white d-flex" 
                    :class="{'opacity-0' : !children}"
                    @click="dropdownBtn"
                    :disabled="!children"
                >
                    <i class="bi bi-caret-right-fill" style="font-size: x-small; color: rgba(255,255,255,0.6);"></i>
                </button>
                <div class="py-0 px-1">
                     <i class="bi bi-bezier2" style="color: rgba(255,255,255,0.8);"></i>
                </div>
                <div class="d-flex px-1">
                    <small class="" style="font-size: 11px;">{{ name }}</small>
                </div>
            </div>
        </div>
        <ul> <!-- this is for children elements -->
        </ul>
    </li>
</template>

<script>
export default {
    name: 'VectorComp',
    props: {
        name: {
            type: String,
            required: false,
            default: "Vector"
        },
        selected: {
            type: Boolean,
            required: true
        },
        children: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        dropdownBtn() {
            alert('button functionality work in progress');
        }
    }
}
</script>

<style scoped>
[elem] {
    transition: 50ms ease all;
}
[elem]:hover {
    background-color: rgba(0,0,0,0.2);
}
</style>
